module.exports = __webpack_public_path__ + "img/9791190652001.c918cdf9.jpg";